export class ThemeSetting {
    animationType?: any;
    backdropBackgroundColour?: any; 
    backdropBorderRadius?: any;
    primaryColour: string;
    secondaryColour:string;
    tertiaryColour?: string;
    accentColour: string;
  }